import '@angular/localize/init';
import 'zone.js/dist/zone';
require('../manifest.webapp');
(window as any).global = window;
